import { defineStore } from "pinia";

export const useGlobalStore = defineStore("zhihao-map-global", {
    // 修改默认值之后，需清除 localStorage 数据
    state: () => ({
        // APP、小程序传入的主题色
        theme: "#FFDB5C",
        // 入口来源 船务小程序/app 1 链云小程序/app 2
        appForm: ""
    }),
    getters: {
        // 会员查询次数仅链云砂石入口启用，船务入口和未标识入口保持无限制查询。
        enableMemberQueryLimit: state => state.appForm === "2"
    },
    actions: {
        // Set GlobalState
        setTheme(theme: string) {
            this.theme = `#${theme}`;
        },
        setAppForm(appForm: string) {
            this.appForm = appForm;
        }
    },
    persist: true
});
